export const appEnvironment = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production'
}
